<template>
  <Panel 
    :title="title"
    width="840px"
    height="90%"
    @closePanel="$emit('close')"
  >
		<EmptyState v-if="events.length == 0" title="No events yet" />

		<table v-else class="zn-event-table">
			<thead>
				<tr>
					<th>Shop URL</th>
					<th>Shop owner</th>
					<th>Email</th>
					<th>Shopify plan</th>
					<th>Zeno plan</th>
					<th>Address</th>
					<th>Country</th>
					<th>Time zone</th>
					<th>Zip code</th>
					<th>Phone</th>
					<th v-if="events[0].date">Time</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="event in events" :key="event.shop.id">
					<td>{{ event.shop.name }}</td>
					<td>{{ event.shop.details.shop_owner }}</td>
					<td>{{ event.shop.details.email }}</td>
					<td>{{ event.shop.details.plan_display_name }}</td>
					<td>{{ event.shop.plan }}</td>
					<td>{{ event.shop.details.address1 }} {{ event.shop.details.address2 }}</td>
					<td>{{ event.shop.details.country_name }}</td>
					<td>{{ event.shop.details.timezone }}</td>
					<td>{{ event.shop.details.zip }}</td>
					<td>{{ event.shop.details.phone }}</td>
					<td v-if="event.date">{{ event.date }}</td>
				</tr>
			</tbody>
		</table>
  </Panel>
</template>

<script>
import Panel from '@/components/common/Panel'

export default {
  components: {
    Panel
  },
  props: {
    title: String,
		events: Array,
  }
}
</script>

<style lang="scss" scoped>
.zn-event-table {
	border-collapse: collapse;
  width: 1200px;

	td, th {
		border: 1px solid $light;
		padding: 8px;
	}

	tr {
		&:nth-child(even) {
			background-color: rgba($light, 0.5);
		}
	}

	th {
		padding-top: 12px;
		padding-bottom: 12px;
		text-align: left;
		background-color: $primary;
		color: white;
	}
}
</style>